import { render, staticRenderFns } from "./InnerPageMessage.vue?vue&type=template&id=2c0acc4c"
import script from "./InnerPageMessage.vue?vue&type=script&lang=js"
export * from "./InnerPageMessage.vue?vue&type=script&lang=js"
import style0 from "./InnerPageMessage.vue?vue&type=style&index=0&id=2c0acc4c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports